import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import {
  BoxQuestionnaireSelectType,
  BoxQuestionnaireStatus,
  PublicBoxQuestionnaireFileResponse,
  PublicBoxQuestionnaireOrderResponse,
} from '@web/shared/module/shop';
import { AdminBoxQuestionnaireContextOperationsResponse } from './admin-box-questionnaire-context-operations.response';

@jsonObject
export class AdminBoxQuestionnaireCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly ownerName!: string;

  @jsonMember(Boolean)
  public readonly isShown!: boolean;

  @jsonMember(Boolean)
  public readonly hasError!: boolean;

  @jsonMember(String)
  public readonly status!: BoxQuestionnaireStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly endDate!: Date;

  @jsonMember(PublicBoxQuestionnaireFileResponse)
  public readonly logo!: PublicBoxQuestionnaireFileResponse;

  @jsonMember(PublicBoxQuestionnaireOrderResponse)
  public readonly order!: PublicBoxQuestionnaireOrderResponse;

  @jsonMember(AdminBoxQuestionnaireContextOperationsResponse)
  public readonly contextOperations!: AdminBoxQuestionnaireContextOperationsResponse;

  @jsonMember(String)
  public readonly errorMessage?: Nillable<string>;

  @jsonArrayMember(String)
  public readonly selectTypes!: BoxQuestionnaireSelectType[];
}
